import styled from 'styled-components';

const coverSize = '100%';
const overlayContentPaddingTopBottom = '8px';
const overlayContentPaddingLeftRight = '16px';
const transitionDuration = '0.5s';
const titleLineHeight = '24px';
const subtitleLineHeight = '24px';

const Overlay = styled.div`
  width: 100%;
  overflow: hidden;
`;

const Container = styled.div`
  position: relative;
  overflow: hidden;
  cursor: pointer;
  width: 194px;
  height: 244px;
  border-radius: 15px;
  background-color: #5f5f5f;
  padding: 12px;

  // &:hover ${Overlay} {
  //   bottom: calc(${overlayContentPaddingTopBottom} * -2);
  //   background: rgba(0, 0, 0, 0.9);
  //   transition: all ${transitionDuration} ease;
  // }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 100%;
  gap: 16px;
`;

const Subtitle = styled.div`
  font-size: ${props => props.theme.typography.fontSize.m};
  min-height: ${subtitleLineHeight};
  width: calc(${coverSize} - ${overlayContentPaddingLeftRight} * 2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: ${props => props.theme.typography.fontSize.m};
  min-height: ${titleLineHeight};
  width: calc(${coverSize} - ${overlayContentPaddingLeftRight} * 2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Info = styled.div`
  font-size: ${props => props.theme.typography.fontSize.s};
  overflow: hidden;
`;

export default {
  Container,
  Overlay,
  Content,
  Subtitle,
  Title,
  Info,
};
